/**
 * Created by user on 2019/4/28.
 */
import request from '@bluelovers/request-promise';

export { request }

export default request
